// extracted by mini-css-extract-plugin
export default {"container":"History_container__OA+zP","history":"History_history__n-ryx","text":"History_text__OJnV+","date":"History_date__JCBww"};